import React, { useState } from 'react';

const questions = [
  {
    question: "How is this different from cloud gaming?",
    answer: "Cloud gaming streams a remote computer to your device. Our approach is fundamentally different, focusing on dividing a game's graphical workload between your computer's GPU and a powerful remote GPU. This improves performance dramatically with lower latency and creates a more native experience.",
  },
  {
    question: "What games can I play?",
    answer: "Technically, refray works with any graphical application. But, there's a catch—games that use anti-cheat software sometimes think using refray is cheating. We're working on solutions to support these games, but for now, you can play most games without issues.",
  },
  {
    question: "Is there really no lag or latency?",
    answer: "We are working super hard to minimize latency until it's negligible. While achieving absolute zero delay in any real-world, network-dependent system is technically challenging, you can genuinely expect a minimal and unnoticeable delay when playing.",
  },
  {
    question: "What GPUs do you use?",
    answer: "Our goal is to make your gaming experience awesome. We want to choose hardware that provides a premium visual experience while keeping our monthly cost low, so this is something that's still in the works.",
  },
  {
    question: "What plans do you offer?",
    answer: "We are still working on developing our tech so that it's more affordable for everyone. We can't say anything just yet, but we know that we want you to be happy with your gaming experience regardless of which plan you're in.",
  },
  {
    question: "What FPS do I get?",
    answer: "We aim for at least 1080p 60fps on high settings in most games when playing on average hardware and internet. With better internet, Refray can push you to 120fps or more.",
  },
  {
    question: "Can I cancel anytime?",
    answer: "Yes. You can cancel your subscription at any time. There are no long-term commitments or cancellation fees.",
  },
  {
    question: "What happens after the beta ends?",
    answer: "If you were a beta tester, you will get a lifetime discount on refray cloud GPUs. Other users can sign up at the regular price with full access.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAnswer = (index: any) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-12 px-4 lg:px-24 grid grid-cols-1 gap-y-20 md:mx-20 font-inter" id="faq">
      <h2 className="text-[2.5rem] md:text-[4.5rem] max-w-5xl text-center mx-auto text-white">
        Frequently asked questions
      </h2>

      <div className="grid grid-cols-1 gap-y-6 max-w-3xl mx-auto w-full">
        {questions.map((item, index) => (
  <div
    key={index}
    className="overflow-hidden bg-card transition-all duration-300 ease-in-out"
    data-aos="fade-up"
    data-aos-delay={`${index * 100}`}
  >
    <button
      className="w-full text-left p-6 flex justify-between items-center text-white outline-none"
      onClick={() => toggleAnswer(index)}
      aria-expanded={openIndex === index ? "true" : "false"}
      aria-controls={`faq-answer-${index}`}
    >
      <div className="text-xl md:text-2xl font-semibold pr-4">
        {item.question}
      </div>
      <svg
        className={`w-7 h-7 text-white transform transition-transform ${
          openIndex === index ? 'rotate-180' : ''
        }`}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
      </svg>
    </button>

    {openIndex === index && (
      <div
        id={`faq-answer-${index}`}
        role="region"
        aria-labelledby={`faq-question-${index}`}
        className="p-6 pt-0 text-white text-lg leading-relaxed animate-grow-in"
      >
        {item.answer}
      </div>
    )}
  </div>
))}
      </div>
    </section>
  );
}
